import { ListingConfig } from "./index";

export const BulkReceiptConfig: ListingConfig = {
  reportConfig: {
    reportId: "E8qqqM2UgsBQ3iQ7T88E",
  },
  // Defines the primary date field in the 'capturedBulkReceipt' collection for date range filtering
  dateField: "transactionDate", // Assuming 'transactionDate' is the correct field for date filtering

  filterConfig: [
    {
      fieldIdToFilter: "documentNumber",
      label: "Document #",
      paramName: "documentNumber",
      placeholder: "e.g. T000-000-001",
      // No sourceCollection indicates this is a text input filter
    },
    {
      // Field in the 'capturedBulkReceipt' collection (templateName) to filter on
      fieldIdToFilter: "tankId", // Assuming bulk receipts are associated with a tankId
      label: "Tank", // Label for the Select dropdown
      paramName: "tank", // URL query parameter name
      sourceCollection: "tanks", // Firestore collection to fetch options from
      // sourceFieldForValue: "id", // Implicitly use document ID as the value
      sourceFieldForLabel: "name", // Field in 'tanks' documents for the dropdown label
                                  // Adjust "name" if your tanks collection uses a different field.
    }
  ],
  fieldConfig: {
    companyId: {
      label: "CompanyId",
      tableRank: -1,
      detailsRank: -1,
      editable: false,
      type: "STRING",
    },
    createdBy: {
      label: "Creator",
      tableRank: -1,
      detailsRank: -1,
      editable: false,
      type: "STRING",
    },
    deliveryRegistrationNumber: {
      label: "Delivery registration",
      tableRank: -1,
      detailsRank: 1,
      editable: false,
      type: "STRING",
    },
    deliveryRegistrationNumberPhoto: {
      label: "Delivery registration photo",
      tableRank: -1,
      detailsRank: 2,
      editable: false,
      type: "IMAGE",
    },
    deviceCaptured: {
      label: "Device captured date",
      tableRank: -1,
      detailsRank: -1,
      editable: false,
      type: "DATE",
    },
    dipReadingBefore: {
      label: "Dip reading before",
      tableRank: -1,
      detailsRank: 6,
      editable: true,
      type: "NUMBER",
    },
    dipReadingBeforePhoto: {
      label: "Dip reading before photo",
      tableRank: -1,
      detailsRank: 7,
      editable: false,
      type: "IMAGE",
    },
    dipReadingAfter: {
      label: "Dip reading after",
      tableRank: -1,
      detailsRank: 8,
      editable: true,
      type: "NUMBER",
    },
    dipReadingAfterPhoto: {
      label: "Dip reading after photo",
      tableRank: -1,
      detailsRank: 9,
      editable: false,
      type: "IMAGE",
    },
    documentNumber: {
      label: "Document #",
      tableRank: 3,
      detailsRank: 100,
      editable: false,
      type: "STRING",
    },
    gpsLocation: {
      label: "Location",
      tableRank: -1,
      detailsRank: 12,
      editable: false,
      type: "COORDINATE",
    },
    isModified: {
      label: "Entry modified",
      tableRank: -1,
      detailsRank: 13,
      editable: false,
      type: "BOOLEAN",
    },
    litersReceived: {
      label: "Litres",
      tableRank: 2,
      detailsRank: 14,
      editable: true,
      type: "NUMBER",
    },
    pumpAttendantSignature: {
      label: "Pump attendant signed",
      tableRank: -1,
      detailsRank: 15,
      editable: false,
      type: "STRING",
    },
    pumpAttendantSignatureImage: {
      label: "Pump attendant signature",
      tableRank: -1,
      detailsRank: 16,
      editable: false,
      type: "IMAGE",
    },
    supplierDeliveryNoteNumberPhoto: {
      label: "Receipt delivery note photo",
      tableRank: -1,
      detailsRank: 17,
      editable: false,
      type: "IMAGE",
    },
    receivedOnServer: {
      label: "xx", // Consider a more descriptive label or hiding if purely internal
      tableRank: -1,
      detailsRank: -1,
      editable: false,
      type: "STRING", // Should this be DATE if it's a timestamp?
    },
    supplier: {
      label: "Supplier",
      tableRank: 3,
      detailsRank: -1,
      editable: false,
      type: "STRING",
    },
    supplierId: {
      label: "Supplier",
      tableRank: -1,
      detailsRank: 18,
      editable: true,
      type: "SELECT",
      sourceCollection: "suppliers",
      sourceFieldForLabel: "name",
      adjacentFields: {
        supplier: "name",
      }
    },
    supplierDeliveryNoteNumber: {
      label: "Supplier delivery note",
      tableRank: -1, // Consider giving this a tableRank if important for display
      detailsRank: 19,
      editable: true,
      type: "STRING",
    },
    supplierDriverName: {
      label: "Supplier driver name",
      tableRank: -1,
      detailsRank: 21,
      editable: true,
      type: "STRING",
    },
    supplierPumpReadingAfter: {
      label: "Supplier pump reading after",
      tableRank: -1,
      detailsRank: 22,
      editable: true,
      type: "STRING", // Or NUMBER?
    },
    supplierPumpReadingAfterPhoto: {
      label: "Supplier pump reading after photo",
      tableRank: -1,
      detailsRank: 23,
      editable: false,
      type: "IMAGE",
    },
    supplierPumpReadingBefore: {
      label: "Supplier pump reading before",
      tableRank: -1,
      detailsRank: 24,
      editable: true,
      type: "STRING", // Or NUMBER?
    },
    supplierPumpReadingBeforePhoto: {
      label: "Supplier pump reading before photo",
      tableRank: -1,
      detailsRank: 25,
      editable: false,
      type: "IMAGE",
    },
    supplierSignedImage: {
      label: "Supplier signature image",
      tableRank: -1,
      detailsRank: 27,
      editable: false,
      type: "IMAGE",
    },
    syncCompleted: {
      label: "xx", // Consider a more descriptive label or hiding if purely internal
      tableRank: -1,
      detailsRank: -1,
      editable: false,
      type: "STRING", // Should this be BOOLEAN?
    },
    tankFuelType: {
      label: "Fuel type",
      tableRank: -3, // Negative ranks usually mean hidden from table
      detailsRank: 29,
      editable: false,
      type: "STRING",
    },
    tankIsMobile: {
      label: "Tank is mobile",
      tableRank: -1,
      detailsRank: 30,
      editable: false,
      type: "STRING", // Should this be BOOLEAN?
    },
    tankName: {
      label: "Tank name",
      tableRank: 4,
      detailsRank: -1,
      editable: false,
      type: "STRING",
    },
    tankId: { 
      label: "Tank",
      tableRank: -1, 
      detailsRank: 31, 
      editable: true,
      type: "SELECT",
      sourceCollection: "tanks",
      sourceFieldForLabel: "name",
      adjacentFields: {
        tankFuelType: "fuelType",
        tankIsMobile: "mobileTank",
        tankName: "name",
        tankSizeLiters: "size"
      }
    },
    tankSealPhotos: {
      label: "Tank seal photo",
      tableRank: -1,
      detailsRank: 32,
      editable: false,
      type: "IMAGE",
    },
    tankSizeLiters: { // Corrected typo from Liters to Litres if that's your convention
      label: "Tank size",
      tableRank: -1,
      detailsRank: 33,
      editable: false,
      type: "NUMBER",
    },
    transactionDate: { // This is the dateField
      label: "Date",
      tableRank: 0,
      detailsRank: 0,
      editable: true,
      type: "DATE",
    },
    waterInTank: {
      label: "Water in tank",
      tableRank: -1,
      detailsRank: 40,
      editable: false,
      type: "BOOLEAN",
    },
    id: {
      label: "ID",
      tableRank: -1,
      detailsRank: -1,
      editable: false,
      type: "STRING",
    },
    transactionReviewed: {
      label: "Reviewed",
      tableRank: -1,
      detailsRank: -1,
      editable: false,
      type: "BOOLEAN",
    }
  },
};
